import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '@components/Button';
import { UPDATE_INVITE_LINK } from '@redux/easyaccess/types';
import ItemCheck from './ItemCheck';
import StepsCompleted from './StepsCompleted';
import * as S from './styles';

class CheckSteps extends Component {
  state = {
    completeLater: false,
    businessManagerLink: null,
  };

  completeLater = () => {
    this.setState({
      completeLater: true,
    });
  };

  componentDidMount() {
    const {
      props: {
        dispatch,
        token,
        easyAccessReducer: { step },
      },
    } = this;

    if (
      step.facebook_user_is_on_business_manager &&
      (step.facebook_page_is_on_business_manager || !step.facebook_page_invite_acceptance_link)
    ) {
      this.completeLater();
    }
    if (step.facebook_business_manager_invitation_link !== null) {
      this.setState({
        businessManagerLink: step.facebook_business_manager_invitation_link,
      });
    }

    if (
      !step.facebook_user_is_on_business_manager &&
      step.facebook_business_manager_invitation_link == null
    ) {
      dispatch({
        type: UPDATE_INVITE_LINK.REQUEST,
        token,
        version: '1.0',
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      props: {
        easyAccessReducer: { step },
      },
    } = this;

    if (
      prevProps.easyAccessReducer.step.facebook_business_manager_invitation_link !==
      step.facebook_business_manager_invitation_link
    ) {
      this.setState({
        businessManagerLink: step.facebook_business_manager_invitation_link,
      });
    }
  }

  render() {
    const {
      state,
      props: {
        t,
        token,
        easyAccessReducer: { step },
      },
    } = this;

    return (
      <S.CardWrapper>
        {!state.completeLater && (
          <>
            <div>
              <S.TitleWrapper>{t('TITLE')}</S.TitleWrapper>
              <S.TextWrapper>{t('SUBTITLE')}</S.TextWrapper>
              <S.TextWrapper>
                {t('TEXT')}
                <S.Tooltip>
                  {t('BUSINESS-MANAGER')}
                  <S.TooltipText>{t('TOOLTIP')} </S.TooltipText>
                </S.Tooltip>
              </S.TextWrapper>
              <S.CheckerWrapper>
                <ItemCheck
                  name="Convite"
                  status={step.facebook_user_is_on_business_manager ? 'checked' : 'active'}
                  link={state.businessManagerLink}
                  token={token}
                  completeLater={this.completeLater}
                />

                <ItemCheck
                  name="Pagina"
                  status={
                    step.facebook_page_is_on_business_manager ||
                    !step.facebook_page_invite_acceptance_link
                      ? 'checked'
                      : 'active'
                  }
                  link={step.facebook_page_invite_acceptance_link}
                />
                {/* <ItemCheck name='Conta de anúncio' status='disabled' /> */}
              </S.CheckerWrapper>
              <S.ButtonWrapper>
                <Button
                  type="button"
                  onClick={(e) => this.completeLater(e)}
                  fontSize="16px"
                  size="EAcustom"
                >
                  {t('COMPLETE_LATER')}
                </Button>
              </S.ButtonWrapper>
            </div>
          </>
        )}
        {state.completeLater && <StepsCompleted />}
      </S.CardWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  easyAccessReducer: state.easyAccessReducer,
});

export default withRouter(connect(mapStateToProps)(translate('CheckSteps')(CheckSteps)));
